import React, { useState } from 'react';
import { DesktopNav, MobileNav } from './Navigation';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-temple">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_krishna-gallery/artifacts/0mnn7ivs_1000003725.png"
              alt="Temple Logo"
              className="w-8 h-8 animate-om"
            />
            <div>
              <h1 className="text-lg font-bold text-saffron">SREE KRISHNASWAMY DEVASWOM</h1>
              <p className="text-xs text-gray-600">KODUNGALLUR</p>
            </div>
          </div>

          <DesktopNav scrollToSection={scrollToSection} />

          <button
            className="lg:hidden text-saffron"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>

        {isMenuOpen && <MobileNav scrollToSection={scrollToSection} />}
      </div>
    </header>
  );
};

export default Header;
